import { openModal } from '../../../core/actions/omniSearch';

const toggleUserProfile = () => (dispatch) => {
  openModal(dispatch)();
};

export default toggleUserProfile;
